import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "p-6 space-y-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-2xl font-bold text-emerald-600 dark:text-emerald-400" }
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "text-2xl font-bold text-amber-600 dark:text-amber-400" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-2xl font-bold text-violet-600 dark:text-violet-400" }
const _hoisted_13 = { class: "flex items-center space-x-3" }
const _hoisted_14 = {
  class: "flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500 text-white font-semibold text-sm shadow-md-custom",
  style: {"box-shadow":"var(--shadow-md)"}
}
const _hoisted_15 = { class: "text-sm font-medium text-emerald-900 dark:text-emerald-100" }
const _hoisted_16 = { class: "flex items-center space-x-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-4" }
const _hoisted_21 = { class: "relative flex-1 max-w-md" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "mt-2 text-sm font-medium text-red-700 dark:text-red-300" }
const _hoisted_25 = { class: "overflow-x-auto" }
const _hoisted_26 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_27 = { class: "bg-gray-50 dark:bg-gray-800/80" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_30 = ["checked", "indeterminate"]
const _hoisted_31 = {
  key: 1,
  class: "flex items-center space-x-1"
}
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col ml-1"
}
const _hoisted_33 = { class: "bg-white dark:bg-gray-800/90 divide-y divide-gray-200 dark:divide-gray-700/30" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "flex items-center justify-center" }
const _hoisted_36 = ["checked", "onChange"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "flex items-center" }
const _hoisted_39 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_40 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-0.5 font-mono" }
const _hoisted_41 = ["title"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "mr-1" }
const _hoisted_45 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400 mt-1 font-mono"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "flex flex-col" }
const _hoisted_49 = { class: "flex items-center space-x-2" }
const _hoisted_50 = { class: "mr-1" }
const _hoisted_51 = {
  key: 0,
  class: "text-amber-500",
  title: "Includes PDF/File"
}
const _hoisted_52 = ["title"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "px-6 py-4" }
const _hoisted_57 = { class: "flex items-center space-x-1" }
const _hoisted_58 = { class: "relative group" }
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_61 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_62 = { class: "relative group" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "relative group" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "relative group" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "bg-gray-50 dark:bg-gray-700/30"
}
const _hoisted_69 = {
  colspan: "8",
  class: "px-6 py-4"
}
const _hoisted_70 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_71 = { class: "space-y-3" }
const _hoisted_72 = {
  class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 shadow-xs",
  style: {"box-shadow":"var(--shadow-xs)"}
}
const _hoisted_73 = { class: "space-y-2 text-sm" }
const _hoisted_74 = { class: "flex items-center justify-between" }
const _hoisted_75 = { class: "mt-1 font-mono text-xs text-gray-900 dark:text-white break-all bg-gray-100 dark:bg-gray-900 p-2 rounded" }
const _hoisted_76 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_77 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "mt-1 space-y-1" }
const _hoisted_80 = { class: "font-mono text-violet-600 dark:text-violet-400" }
const _hoisted_81 = { class: "ml-2 font-mono text-gray-600 dark:text-gray-400 truncate" }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { class: "mt-1 p-2 bg-gray-100 dark:bg-gray-900 rounded text-xs text-gray-800 dark:text-gray-200 overflow-x-auto" }
const _hoisted_84 = { class: "space-y-3" }
const _hoisted_85 = {
  class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 shadow-xs",
  style: {"box-shadow":"var(--shadow-xs)"}
}
const _hoisted_86 = { class: "space-y-3" }
const _hoisted_87 = { class: "mt-1 p-2 bg-gray-100 dark:bg-gray-900 rounded text-xs text-gray-800 dark:text-gray-200 overflow-x-auto max-h-32 whitespace-pre-wrap" }
const _hoisted_88 = {
  key: 0,
  class: "pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_89 = { class: "mt-2 space-y-1 text-xs" }
const _hoisted_90 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_91 = { class: "font-mono text-gray-900 dark:text-white" }
const _hoisted_92 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_93 = { class: "font-mono text-gray-900 dark:text-white" }
const _hoisted_94 = {
  key: 2,
  class: "flex items-center justify-between"
}
const _hoisted_95 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_96 = {
  key: 3,
  class: "flex items-center justify-between"
}
const _hoisted_97 = { class: "font-mono text-gray-900 dark:text-white" }
const _hoisted_98 = { class: "text-gray-500" }
const _hoisted_99 = { class: "space-y-3" }
const _hoisted_100 = {
  class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 shadow-xs",
  style: {"box-shadow":"var(--shadow-xs)"}
}
const _hoisted_101 = { class: "space-y-2 text-sm" }
const _hoisted_102 = { class: "flex items-center justify-between" }
const _hoisted_103 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_104 = { class: "font-mono text-xs text-gray-900 dark:text-white" }
const _hoisted_105 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_106 = { class: "font-mono text-xs text-gray-900 dark:text-white" }
const _hoisted_107 = {
  key: 2,
  class: "flex items-center justify-between"
}
const _hoisted_108 = { class: "font-mono text-xs text-gray-900 dark:text-white" }
const _hoisted_109 = {
  key: 3,
  class: "flex items-center justify-between"
}
const _hoisted_110 = { class: "font-mono text-xs text-gray-900 dark:text-white" }
const _hoisted_111 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_112 = { class: "mt-1 space-y-1 text-xs" }
const _hoisted_113 = { class: "flex items-center justify-between" }
const _hoisted_114 = { class: "text-gray-900 dark:text-white font-mono" }
const _hoisted_115 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_116 = { class: "text-gray-900 dark:text-white" }
const _hoisted_117 = {
  key: 1,
  class: "flex items-start justify-between"
}
const _hoisted_118 = { class: "text-gray-900 dark:text-white text-right max-w-[200px]" }
const _hoisted_119 = {
  key: 2,
  class: "flex items-start justify-between"
}
const _hoisted_120 = { class: "text-gray-900 dark:text-white text-right max-w-[200px]" }
const _hoisted_121 = {
  key: 0,
  class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 shadow-xs",
  style: {"box-shadow":"var(--shadow-xs)"}
}
const _hoisted_122 = { class: "space-y-2 text-xs" }
const _hoisted_123 = { class: "mt-1 text-gray-700 dark:text-gray-300" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "mt-1 text-emerald-600 dark:text-emerald-400 font-medium" }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { class: "mt-1 text-violet-600 dark:text-violet-400 font-medium" }
const _hoisted_128 = {
  class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 shadow-xs",
  style: {"box-shadow":"var(--shadow-xs)"}
}
const _hoisted_129 = { class: "space-y-2 text-xs" }
const _hoisted_130 = { class: "flex items-center justify-between" }
const _hoisted_131 = { class: "font-mono text-gray-900 dark:text-white" }
const _hoisted_132 = { class: "flex items-center justify-between" }
const _hoisted_133 = { class: "font-mono text-gray-900 dark:text-white" }
const _hoisted_134 = { class: "flex items-center justify-between" }
const _hoisted_135 = { class: "text-gray-900 dark:text-white" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = {
  colspan: "8",
  class: "px-6 py-12 text-center"
}
const _hoisted_138 = { class: "mt-1 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_139 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_140 = { class: "flex items-center space-x-2" }
const _hoisted_141 = ["disabled"]
const _hoisted_142 = { class: "flex items-center space-x-1" }
const _hoisted_143 = ["onClick"]
const _hoisted_144 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_145 = ["disabled"]
const _hoisted_146 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_147 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0" }
const _hoisted_148 = { class: "px-6 pt-6 pb-4" }
const _hoisted_149 = { class: "flex items-center" }
const _hoisted_150 = { class: "ml-4" }
const _hoisted_151 = { class: "text-lg font-semibold text-gray-900 dark:text-white" }
const _hoisted_152 = { class: "mt-1 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_153 = { key: 0 }
const _hoisted_154 = { key: 1 }
const _hoisted_155 = {
  key: 0,
  class: "mt-3 max-h-32 overflow-y-auto"
}
const _hoisted_156 = { class: "text-xs text-gray-600 dark:text-gray-400 space-y-1" }
const _hoisted_157 = { class: "px-6 py-4 bg-gray-50 dark:bg-gray-700/50 flex justify-end space-x-3" }
const _hoisted_158 = ["disabled"]
const _hoisted_159 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, computed, reactive, inject, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import type { ReportConfig, ListReportsParams, ReportStatus } from '../../types/platform-report'
import { platformReportsService } from '../../services/platform-reports'
import Toast from '../../components/base/common/Toast.vue'
import LoadingState from '../../components/base/common/LoadingState.vue'
import { toString } from 'cronstrue'
import authService from '../../services/auth/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const theme = inject('theme', useTheme())
const router = useRouter()

// State
const reports = ref<ReportConfig[]>([])
const expandedRows = ref<Set<string>>(new Set())
const selectedReports = ref<Set<string>>(new Set())
const searchQuery = ref('')
const activeFilter = ref('all')
const sortField = ref<'createdAt' | 'updatedAt' | 'name'>('updatedAt')
const sortOrder = ref<'asc' | 'desc'>('desc')

// Pagination
const currentPage = ref(1)
const pageSize = ref(20)
const totalReports = ref(0)
const totalPages = ref(0)

// Loading & Error State
const isLoading = ref(false)
const isDeleting = ref(false)
const error = ref<string | null>(null)

// Modal State
const showDeleteModal = ref(false)
const reportToDelete = ref<ReportConfig | null>(null)
const reportsToDelete = ref<ReportConfig[]>([])
const testingReportId = ref<string | null>(null)
const isBulkDeleting = ref(false)

// Toast
const toast = reactive({
  show: false,
  message: '',
  type: 'success' as 'success' | 'error'
})

// Filter Options
const filterOptions = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'With PDF', value: 'withPdf' },
  { label: 'Slack', value: 'slack' }
]

// Columns
const columns = [
  { field: 'select', label: '', sortable: false },
  { field: 'name', label: 'Report Name', sortable: true },
  { field: 'schedule', label: 'Schedule', sortable: false },
  { field: 'method', label: 'Method', sortable: false },
  { field: 'sink', label: 'Destination', sortable: false },
  { field: 'updatedAt', label: 'Last Updated', sortable: true },
  { field: 'status', label: 'Status', sortable: false },
  { field: 'actions', label: 'Actions', sortable: false }
]

// Computed
const stats = computed(() => ({
  total: totalReports.value,
  active: reports.value.filter((r) => r.status === 'active').length,
  withPDF: reports.value.filter((r) => r.transform?.config?.fileConfig?.enabled).length,
  scheduled: reports.value.filter((r) => r.schedule?.type === 'cron').length
}))

// Reports are already filtered and sorted by the API
const filteredReports = computed(() => reports.value)

// Computed for selection
const isAllSelected = computed(() => {
  return (
    filteredReports.value.length > 0 && selectedReports.value.size === filteredReports.value.length
  )
})

const isSomeSelected = computed(() => {
  return selectedReports.value.size > 0 && selectedReports.value.size < filteredReports.value.length
})

const selectedCount = computed(() => selectedReports.value.size)

// Fetch reports from API
const fetchReports = async () => {
  isLoading.value = true
  error.value = null

  try {
    // Build API params
    const params: ListReportsParams = {
      page: currentPage.value,
      limit: pageSize.value,
      sortBy: sortField.value,
      sortOrder: sortOrder.value
    }

    // Add search if present
    if (searchQuery.value) {
      params.search = searchQuery.value
    }

    // Add status filter
    if (
      activeFilter.value === 'active' ||
      activeFilter.value === 'inactive' ||
      activeFilter.value === 'draft'
    ) {
      params.status = activeFilter.value as ReportStatus
    }

    // Add sink type filter
    if (activeFilter.value === 'slack') {
      params.sinkType = 'slack'
    }

    const response = await platformReportsService.listReports(params)

    // Apply client-side filter for withPdf (since mock doesn't support this filter)
    if (activeFilter.value === 'withPdf') {
      response.reports = response.reports.filter((r) => r.transform?.config?.fileConfig?.enabled)
      response.total = response.reports.length
      response.totalPages = Math.ceil(response.total / pageSize.value)
    }

    reports.value = response.reports
    totalReports.value = response.total
    totalPages.value = response.totalPages

    // Clear selections when data changes
    selectedReports.value.clear()
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to fetch reports'
    showToast(error.value, 'error')
  } finally {
    isLoading.value = false
  }
}

// Debounced search
let searchTimeout: ReturnType<typeof setTimeout> | null = null
const debouncedFetch = () => {
  if (searchTimeout) clearTimeout(searchTimeout)
  searchTimeout = setTimeout(() => {
    currentPage.value = 1
    fetchReports()
  }, 300)
}

// Watch for filter/sort changes
watch([activeFilter, sortField, sortOrder], () => {
  currentPage.value = 1
  fetchReports()
})

watch(searchQuery, () => {
  debouncedFetch()
})

watch(currentPage, () => {
  fetchReports()
})

// Methods
const handleSort = (field: string) => {
  const sortableFields = ['name', 'createdAt', 'updatedAt']
  if (!sortableFields.includes(field)) return

  if (sortField.value === field) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field as 'name' | 'createdAt' | 'updatedAt'
    sortOrder.value = 'asc'
  }
}

const toggleExpand = (id: string) => {
  if (expandedRows.value.has(id)) {
    expandedRows.value.delete(id)
  } else {
    expandedRows.value.add(id)
  }
}

const openCreateModal = () => {
  router.push('/platform-report/create')
}

const openEditModal = (report: ReportConfig) => {
  router.push(`/platform-report/edit/${report.id}`)
}

const confirmDelete = (report: ReportConfig) => {
  reportToDelete.value = report
  reportsToDelete.value = [report]
  showDeleteModal.value = true
}

const confirmBulkDelete = () => {
  if (selectedReports.value.size === 0) return

  const selected = reports.value.filter((r) => selectedReports.value.has(r.id))
  reportsToDelete.value = selected
  reportToDelete.value = null
  showDeleteModal.value = true
}

const deleteReport = async () => {
  // Handle single delete
  if (reportToDelete.value) {
    isDeleting.value = true
    try {
      await platformReportsService.deleteReport(reportToDelete.value.id)
      showDeleteModal.value = false
      reportToDelete.value = null
      reportsToDelete.value = []
      showToast('Report deleted successfully', 'success')
      await fetchReports()
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'Failed to delete report'
      showToast(errorMsg, 'error')
    } finally {
      isDeleting.value = false
    }
    return
  }

  // Handle bulk delete with Promise.all
  if (reportsToDelete.value.length > 0) {
    isBulkDeleting.value = true
    isDeleting.value = true

    try {
      // Use Promise.all to delete all reports in parallel
      const deletePromises = reportsToDelete.value.map((report) =>
        platformReportsService.deleteReport(report.id)
      )

      const deleteCount = reportsToDelete.value.length
      await Promise.all(deletePromises)

      // Clear selections
      selectedReports.value.clear()
      showDeleteModal.value = false
      reportsToDelete.value = []
      reportToDelete.value = null

      showToast(
        `Successfully deleted ${deleteCount} ${deleteCount === 1 ? 'report' : 'reports'}`,
        'success'
      )

      // Refresh the list
      await fetchReports()
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'Failed to delete reports'
      showToast(errorMsg, 'error')
    } finally {
      isBulkDeleting.value = false
      isDeleting.value = false
    }
  }
}

// Selection methods
const toggleSelect = (id: string) => {
  if (selectedReports.value.has(id)) {
    selectedReports.value.delete(id)
  } else {
    selectedReports.value.add(id)
  }
}

const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedReports.value.clear()
  } else {
    filteredReports.value.forEach((report) => {
      selectedReports.value.add(report.id)
    })
  }
}

const clearSelection = () => {
  selectedReports.value.clear()
}

const duplicateReport = async (report: ReportConfig) => {
  try {
    // Get current user email
    const user = authService.getUser()
    const userEmail = user?.email || ''

    // Create a copy of the report without the id
    const duplicateData = {
      name: `${report.name || report.id} (Copy)`,
      schedule: report.schedule,
      status: 'draft' as ReportStatus,
      source: report.source,
      transform: report.transform,
      sink: report.sink,
      meta: {
        createdBy: userEmail
      }
    }

    await platformReportsService.createReport(duplicateData)
    showToast('Report duplicated successfully', 'success')
    // Refresh the list
    await fetchReports()
  } catch (err) {
    const errorMsg = err instanceof Error ? err.message : 'Failed to duplicate report'
    showToast(errorMsg, 'error')
  }
}

const toggleActive = async (report: ReportConfig) => {
  try {
    // Get current user email
    const user = authService.getUser()
    const userEmail = user?.email || ''

    const newStatus: ReportStatus = report.status === 'active' ? 'inactive' : 'active'
    await platformReportsService.updateReport(report.id, {
      status: newStatus,
      meta: {
        updatedBy: userEmail
      }
    })
    // Update local state
    report.status = newStatus
    showToast(`Report ${newStatus === 'active' ? 'activated' : 'deactivated'}`, 'success')
  } catch (err) {
    const errorMsg = err instanceof Error ? err.message : 'Failed to update report status'
    showToast(errorMsg, 'error')
  }
}

const testReport = async (report: ReportConfig) => {
  testingReportId.value = report.id

  try {
    const result = await platformReportsService.executeReport(report.id)
    showToast(result.message || `Test completed for "${report.name || report.id}"`, 'success')
  } catch (err) {
    const errorMsg = err instanceof Error ? err.message : 'Failed to execute report'
    showToast(errorMsg, 'error')
  } finally {
    testingReportId.value = null
  }
}

// Pagination methods
const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const showToast = (message: string, type: 'success' | 'error') => {
  toast.message = message
  toast.type = type
  toast.show = true
}

const formatDate = (dateString?: string) => {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Extract email prefix (part before @) or return 'NA'
const getEmailPrefix = (email?: string) => {
  if (!email) return 'NA'
  const parts = email.split('@')
  return parts.length > 0 ? parts[0] : 'NA'
}

// Format epoch timestamp (milliseconds) to IST
const formatEpochToIST = (epochMs?: number | string) => {
  if (!epochMs) return '-'
  // Handle both number and string (for backward compatibility)
  const timestamp = typeof epochMs === 'string' ? parseInt(epochMs, 10) : epochMs
  if (isNaN(timestamp)) return '-'
  const date = new Date(timestamp)
  return `${date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  })} IST`
}

const getMethodColor = (method: string) => {
  const colors: Record<string, string> = {
    GET: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400',
    POST: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400',
    PUT: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400',
    PATCH: 'bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-400',
    DELETE: 'bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400'
  }
  return colors[method] || 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-400'
}

const getSinkActionColor = (action: string) => {
  const colors: Record<string, string> = {
    sendToDM: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400',
    sendToChannel: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400',
    sendToThread: 'bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-400'
  }
  return colors[action] || 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-400'
}

const getSinkIcon = (action: string) => {
  const icons: Record<string, string> = {
    sendToDM: '👤',
    sendToChannel: '#️⃣',
    sendToThread: '🧵'
  }
  return icons[action] || '💬'
}

const formatSinkAction = (action: string) => {
  const labels: Record<string, string> = {
    sendToDM: 'DM',
    sendToChannel: 'Channel',
    sendToThread: 'Thread'
  }
  return labels[action] || action
}

const getScheduleTypeColor = (type?: string) => {
  const colors: Record<string, string> = {
    cron: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400',
    manual: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
  }
  return colors[type || 'manual'] || colors.manual
}

const getScheduleIcon = (type?: string) => {
  const icons: Record<string, string> = {
    cron: '🕐',
    manual: '👆'
  }
  return icons[type || 'manual'] || icons.manual
}

const maskSensitiveValue = (key: string, value: string) => {
  const sensitiveKeys = ['authorization', 'x-api-key', 'token', 'secret', 'password']
  if (sensitiveKeys.some((k) => key.toLowerCase().includes(k))) {
    return `${value.substring(0, 10)}...`
  }
  return value
}

const parseCronExpression = (expression: string) => {
  if (!expression || expression.trim() === '') {
    return expression
  }

  try {
    return toString(expression, {
      use24HourTimeFormat: false,
      throwExceptionOnParseError: false
    })
  } catch {
    return expression
  }
}

// Get IST equivalent time for cron expression
const getISTTime = (expression: string): string | null => {
  if (!expression || expression.trim() === '') {
    return null
  }

  try {
    const parts = expression.trim().split(/\s+/)
    if (parts.length !== 5) {
      return null
    }

    const [minute, hour] = parts

    // Only show IST conversion if we have specific hour and minute (not wildcards)
    if (hour === '*' || minute === '*') {
      return null
    }

    const utcHour = parseInt(hour, 10)
    const utcMinute = parseInt(minute, 10)

    if (isNaN(utcHour) || isNaN(utcMinute)) {
      return null
    }

    // IST is UTC + 5:30
    let istHour = utcHour + 5
    let istMinute = utcMinute + 30

    // Handle minute overflow
    if (istMinute >= 60) {
      istMinute -= 60
      istHour += 1
    }

    // Handle hour overflow
    if (istHour >= 24) {
      istHour -= 24
    }

    // Format time
    const period = istHour >= 12 ? 'PM' : 'AM'
    const displayHour = istHour === 0 ? 12 : istHour > 12 ? istHour - 12 : istHour

    // Get the rest of the cron expression for context
    const [, , dayOfMonth, month, dayOfWeek] = parts
    let schedulePart = ''

    if (dayOfWeek === '1-5' && dayOfMonth === '*' && month === '*') {
      schedulePart = ' on weekdays (Monday-Friday)'
    } else if (dayOfWeek === '*' && dayOfMonth === '*' && month === '*') {
      schedulePart = ' daily'
    } else if (dayOfWeek !== '*' && dayOfMonth === '*' && month === '*') {
      schedulePart = ` on ${getDayName(dayOfWeek)}`
    } else {
      schedulePart = ' (same schedule pattern)'
    }

    return `At ${displayHour}:${istMinute.toString().padStart(2, '0')} ${period} IST${schedulePart}`
  } catch {
    return null
  }
}

// Helper to get day name from cron day of week
const getDayName = (dayOfWeek: string): string => {
  const dayMap: Record<string, string> = {
    '0': 'Sunday',
    '1': 'Monday',
    '2': 'Tuesday',
    '3': 'Wednesday',
    '4': 'Thursday',
    '5': 'Friday',
    '6': 'Saturday',
    '7': 'Sunday'
  }

  if (dayOfWeek.includes('-')) {
    const [start, end] = dayOfWeek.split('-')
    return `${dayMap[start] || start}-${dayMap[end] || end}`
  }

  if (dayOfWeek.includes(',')) {
    return dayOfWeek
      .split(',')
      .map((d) => dayMap[d.trim()] || d.trim())
      .join(', ')
  }

  return dayMap[dayOfWeek] || dayOfWeek
}

// Lifecycle
onMounted(() => {
  fetchReports()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4 shadow-sm-custom'
      ]),
      style: {"box-shadow":"var(--shadow-sm)"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-2xl font-bold'])
          }, " Platform Reports ", 2),
          _createElementVNode("p", {
            class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-1 text-sm'])
          }, " Configure and manage automated HTTP → Template → Slack reports ", 2)
        ]),
        _createElementVNode("button", {
          class: "px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-200 flex items-center space-x-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-400 shadow-md-custom shadow-hover-md",
          style: {"box-shadow":"var(--shadow-md)"},
          onClick: openCreateModal
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
              "clip-rule": "evenodd"
            })
          ], -1),
          _createElementVNode("span", null, "Create Report", -1)
        ]))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg p-4 shadow-sm-custom shadow-hover-md transition-all duration-200'
          ]),
          style: {"box-shadow":"var(--shadow-sm)"}
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(stats.value.total), 1),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Total Reports", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg" }, [
              _createElementVNode("svg", {
                class: "w-6 h-6 text-blue-600 dark:text-blue-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ])
            ], -1))
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg p-4 shadow-sm-custom shadow-hover-md transition-all duration-200'
          ]),
          style: {"box-shadow":"var(--shadow-sm)"}
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(stats.value.active), 1),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Active", -1))
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "p-3 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg" }, [
              _createElementVNode("svg", {
                class: "w-6 h-6 text-emerald-600 dark:text-emerald-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M5 13l4 4L19 7"
                })
              ])
            ], -1))
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg p-4 shadow-sm-custom shadow-hover-md transition-all duration-200'
          ]),
          style: {"box-shadow":"var(--shadow-sm)"}
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(stats.value.withPDF), 1),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400" }, "With PDF/File", -1))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "p-3 bg-amber-100 dark:bg-amber-900/30 rounded-lg" }, [
              _createElementVNode("svg", {
                class: "w-6 h-6 text-amber-600 dark:text-amber-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                })
              ])
            ], -1))
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg p-4 shadow-sm-custom shadow-hover-md transition-all duration-200'
          ]),
          style: {"box-shadow":"var(--shadow-sm)"}
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(stats.value.scheduled), 1),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Scheduled (Cron)", -1))
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "p-3 bg-violet-100 dark:bg-violet-900/30 rounded-lg" }, [
              _createElementVNode("svg", {
                class: "w-6 h-6 text-violet-600 dark:text-violet-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ])
            ], -1))
          ])
        ], 2)
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition-all duration-300 ease-out",
        "enter-from-class": "opacity-0 -translate-y-2",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition-all duration-200 ease-in",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 -translate-y-2"
      }, {
        default: _withCtx(() => [
          (selectedCount.value > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-emerald-900/20 border-emerald-700/50'
              : 'bg-emerald-50 border-emerald-200',
            'border rounded-lg p-4 shadow-lg-custom flex items-center justify-between'
          ]),
                style: {"box-shadow":"var(--shadow-lg)"}
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(selectedCount.value), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(selectedCount.value) + " " + _toDisplayString(selectedCount.value === 1 ? 'report' : 'reports') + " selected ", 1),
                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-emerald-700 dark:text-emerald-300" }, " Click to select or deselect individual reports ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "px-4 py-2 text-sm font-medium text-emerald-700 dark:text-emerald-300 hover:text-emerald-900 dark:hover:text-emerald-100 transition-colors",
                    onClick: clearSelection
                  }, " Clear Selection "),
                  _createElementVNode("button", {
                    class: "px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white rounded-lg text-sm font-medium transition-all duration-200 shadow-md-custom shadow-hover-md flex items-center space-x-2",
                    style: {"box-shadow":"var(--shadow-md)"},
                    disabled: isBulkDeleting.value,
                    onClick: confirmBulkDelete
                  }, [
                    (isBulkDeleting.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[16] || (_cache[16] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[17] || (_cache[17] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          }, null, -1)
                        ]))),
                    _createElementVNode("span", null, _toDisplayString(isBulkDeleting.value ? 'Deleting...' : `Delete ${selectedCount.value}`), 1)
                  ], 8, _hoisted_17)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-4 shadow-sm-custom'
        ]),
        style: {"box-shadow":"var(--shadow-sm)"}
      }, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              class: "w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-100 focus:ring-emerald-500 dark:focus:ring-emerald-400 focus:border-emerald-500 dark:focus:border-emerald-400",
              placeholder: "Search by name, URL, or template..."
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
              _createElementVNode("svg", {
                class: "h-5 w-5 text-gray-400 dark:text-gray-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                })
              ])
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterOptions, (filter) => {
              return _createElementVNode("button", {
                key: filter.value,
                class: _normalizeClass([
                activeFilter.value === filter.value
                  ? 'bg-emerald-500 text-white border-emerald-500 shadow-md-custom'
                  : _unref(theme).isDark.value
                    ? 'bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600 shadow-xs shadow-hover-sm'
                    : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 shadow-xs shadow-hover-sm',
                'px-3 py-1.5 text-sm font-medium border rounded-lg transition-all duration-200'
              ]),
                style: _normalizeStyle(
                activeFilter.value === filter.value
                  ? 'box-shadow: var(--shadow-md);'
                  : 'box-shadow: var(--shadow-xs);'
              ),
                onClick: ($event: any) => (activeFilter.value = filter.value)
              }, _toDisplayString(filter.label), 15, _hoisted_23)
            }), 64))
          ])
        ])
      ], 2),
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingState, {
            key: 0,
            message: "Loading reports..."
          }))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-red-900/20 border-red-800' : 'bg-red-50 border-red-200',
          'border rounded-lg p-6 text-center shadow-md-custom'
        ]),
              style: {"box-shadow":"var(--shadow-md)"}
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                class: "mx-auto h-12 w-12 text-red-500",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                })
              ], -1)),
              _createElementVNode("h3", _hoisted_24, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                class: "mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors text-sm font-medium",
                onClick: fetchReports
              }, " Try Again ")
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg overflow-hidden shadow-md-custom'
        ]),
              style: {"box-shadow":"var(--shadow-md)"}
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("table", _hoisted_26, [
                  _createElementVNode("thead", _hoisted_27, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                        return _createElementVNode("th", {
                          key: column.field,
                          class: _normalizeClass(["px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400", {
                    'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700': column.sortable,
                    'w-12': column.field === 'select'
                  }]),
                          onClick: ($event: any) => (column.sortable && handleSort(column.field))
                        }, [
                          (column.field === 'select')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: isAllSelected.value,
                                  indeterminate: isSomeSelected.value,
                                  class: "w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 rounded focus:ring-emerald-500 dark:focus:ring-emerald-400 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 cursor-pointer transition-all duration-200",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                  onChange: toggleSelectAll
                                }, null, 40, _hoisted_30)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("span", null, _toDisplayString(column.label), 1),
                                (column.sortable)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(["w-3 h-3", 
                          sortField.value === column.field && sortOrder.value === 'asc'
                            ? 'text-emerald-500'
                            : 'text-gray-400'
                        ]),
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20"
                                      }, _cache[20] || (_cache[20] = [
                                        _createElementVNode("path", { d: "M10 3l-7 7h14l-7-7z" }, null, -1)
                                      ]), 2)),
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(["w-3 h-3 -mt-1", 
                          sortField.value === column.field && sortOrder.value === 'desc'
                            ? 'text-emerald-500'
                            : 'text-gray-400'
                        ]),
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20"
                                      }, _cache[21] || (_cache[21] = [
                                        _createElementVNode("path", { d: "M10 17l7-7H3l7 7z" }, null, -1)
                                      ]), 2))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 10, _hoisted_28)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReports.value, (report) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: report.id
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass([
                    'hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-all duration-200',
                    selectedReports.value.has(report.id) ? 'bg-emerald-50/50 dark:bg-emerald-900/10' : ''
                  ]),
                          style: {"transition":"background-color 0.2s ease-in-out,\n                      box-shadow 0.2s ease-in-out"}
                        }, [
                          _createElementVNode("td", {
                            class: "px-6 py-4",
                            onClick: _withModifiers(($event: any) => (toggleSelect(report.id)), ["stop"])
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: selectedReports.value.has(report.id),
                                class: "w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 rounded focus:ring-emerald-500 dark:focus:ring-emerald-400 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 cursor-pointer transition-all duration-200 shadow-xs",
                                style: {"box-shadow":"var(--shadow-xs)"},
                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                                onChange: ($event: any) => (toggleSelect(report.id))
                              }, null, 40, _hoisted_36)
                            ])
                          ], 8, _hoisted_34),
                          _createElementVNode("td", {
                            class: "px-6 py-4 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                          report.status === 'active'
                            ? 'bg-emerald-500'
                            : report.status === 'draft'
                              ? 'bg-amber-500'
                              : 'bg-gray-400',
                          'w-2 h-2 rounded-full mr-3'
                        ])
                              }, null, 2),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_39, _toDisplayString(report.name || report.id), 1),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("span", {
                                    class: "inline-flex items-center px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded text-[10px]",
                                    title: report.id
                                  }, _toDisplayString(report.id), 9, _hoisted_41)
                                ])
                              ])
                            ])
                          ], 8, _hoisted_37),
                          _createElementVNode("td", {
                            class: "px-6 py-4 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                          getScheduleTypeColor(report.schedule?.type),
                          'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium'
                        ])
                              }, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(getScheduleIcon(report.schedule?.type)), 1),
                                _createTextVNode(" " + _toDisplayString(report.schedule?.type || 'manual'), 1)
                              ], 2)
                            ]),
                            (report.schedule?.expression)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(report.schedule.expression), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_42),
                          _createElementVNode("td", {
                            class: "px-6 py-4 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        getMethodColor(report.source.config.method),
                        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium'
                      ])
                            }, _toDisplayString(report.source.config.method), 3)
                          ], 8, _hoisted_46),
                          _createElementVNode("td", {
                            class: "px-6 py-4 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                            getSinkActionColor(report.sink.config.action),
                            'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium'
                          ])
                                }, [
                                  _createElementVNode("span", _hoisted_50, _toDisplayString(getSinkIcon(report.sink.config.action)), 1),
                                  _createTextVNode(" " + _toDisplayString(formatSinkAction(report.sink.config.action)), 1)
                                ], 2),
                                (report.transform.config.fileConfig?.enabled)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, " 📎 "))
                                  : _createCommentVNode("", true)
                              ]),
                              (
                          report.sink.config.userId ||
                          report.sink.config.channelId ||
                          (report.sink.config.userIds && report.sink.config.userIds.length > 0)
                        )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "text-xs text-gray-500 dark:text-gray-400 font-mono mt-1 truncate max-w-[150px]",
                                    title: 
                          report.sink.config.userId ||
                          report.sink.config.channelId ||
                          (report.sink.config.userIds ? report.sink.config.userIds.join(', ') : '')
                        
                                  }, _toDisplayString(report.sink.config.userId ||
                          report.sink.config.channelId ||
                          (report.sink.config.userIds
                            ? `${report.sink.config.userIds.length} users`
                            : '')), 9, _hoisted_52))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_47),
                          _createElementVNode("td", {
                            class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, _toDisplayString(formatDate(report.updatedAt)), 9, _hoisted_53),
                          _createElementVNode("td", {
                            class: "px-6 py-4 cursor-pointer",
                            onClick: ($event: any) => (toggleExpand(report.id))
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass([
                        report.status === 'active'
                          ? 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400'
                          : report.status === 'draft'
                            ? 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400'
                            : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400',
                        'px-3 py-1 rounded-full text-xs font-medium transition-colors capitalize'
                      ]),
                              onClick: _withModifiers(($event: any) => (toggleActive(report)), ["stop"])
                            }, _toDisplayString(report.status), 11, _hoisted_55)
                          ], 8, _hoisted_54),
                          _createElementVNode("td", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["p-1.5 text-emerald-500 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 rounded-lg transition-all duration-200 shadow-xs shadow-hover-sm", {
                            'opacity-50 cursor-not-allowed': testingReportId.value === report.id
                          }]),
                                  style: {"box-shadow":"var(--shadow-xs)"},
                                  disabled: testingReportId.value === report.id,
                                  onClick: _withModifiers(($event: any) => (testReport(report)), ["stop"])
                                }, [
                                  (testingReportId.value !== report.id)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_60, _cache[22] || (_cache[22] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        }, null, -1)
                                      ])))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_61, _cache[23] || (_cache[23] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                        }, null, -1)
                                      ])))
                                ], 10, _hoisted_59),
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10" }, [
                                  _createTextVNode(" Trigger "),
                                  _createElementVNode("div", { class: "absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700" })
                                ], -1))
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                  class: "p-1.5 text-blue-500 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg transition-all duration-200 shadow-xs shadow-hover-sm",
                                  style: {"box-shadow":"var(--shadow-xs)"},
                                  onClick: _withModifiers(($event: any) => (openEditModal(report)), ["stop"])
                                }, _cache[25] || (_cache[25] = [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_63),
                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10" }, [
                                  _createTextVNode(" Edit "),
                                  _createElementVNode("div", { class: "absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700" })
                                ], -1))
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("button", {
                                  class: "p-1.5 text-violet-500 dark:text-violet-400 hover:bg-violet-50 dark:hover:bg-violet-900/30 rounded-lg transition-all duration-200 shadow-xs shadow-hover-sm",
                                  style: {"box-shadow":"var(--shadow-xs)"},
                                  onClick: _withModifiers(($event: any) => (duplicateReport(report)), ["stop"])
                                }, _cache[27] || (_cache[27] = [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_65),
                                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10" }, [
                                  _createTextVNode(" Duplicate "),
                                  _createElementVNode("div", { class: "absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700" })
                                ], -1))
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("button", {
                                  class: "p-1.5 text-rose-500 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-lg transition-all duration-200 shadow-xs shadow-hover-sm",
                                  style: {"box-shadow":"var(--shadow-xs)"},
                                  onClick: _withModifiers(($event: any) => (confirmDelete(report)), ["stop"])
                                }, _cache[29] || (_cache[29] = [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_67),
                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10" }, [
                                  _createTextVNode(" Delete "),
                                  _createElementVNode("div", { class: "absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700" })
                                ], -1))
                              ])
                            ])
                          ])
                        ], 2),
                        (expandedRows.value.has(report.id))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                              _createElementVNode("td", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, [
                                    _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white flex items-center" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 mr-2 text-blue-500",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                                        })
                                      ]),
                                      _createTextVNode(" HTTP Source ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("div", _hoisted_74, [
                                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Method:", -1)),
                                          _createElementVNode("span", {
                                            class: _normalizeClass([
                                  getMethodColor(report.source.config.method),
                                  'px-2 py-0.5 rounded text-xs font-medium'
                                ])
                                          }, _toDisplayString(report.source.config.method), 3)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "URL:", -1)),
                                          _createElementVNode("div", _hoisted_75, _toDisplayString(report.source.config.url), 1)
                                        ]),
                                        (report.source.config.timeout)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Timeout:", -1)),
                                              _createElementVNode("span", _hoisted_77, _toDisplayString(report.source.config.timeout / 1000) + "s", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                                report.source.config.headers &&
                                Object.keys(report.source.config.headers).length > 0
                              )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Headers:", -1)),
                                              _createElementVNode("div", _hoisted_79, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.source.config.headers, (value, key) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: key,
                                                    class: "flex items-center text-xs"
                                                  }, [
                                                    _createElementVNode("span", _hoisted_80, _toDisplayString(key) + ":", 1),
                                                    _createElementVNode("span", _hoisted_81, _toDisplayString(maskSensitiveValue(key as string, value)), 1)
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (report.source.config.body)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Body:", -1)),
                                              _createElementVNode("pre", _hoisted_83, _toDisplayString(JSON.stringify(report.source.config.body, null, 2)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_84, [
                                    _cache[43] || (_cache[43] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white flex items-center" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 mr-2 text-violet-500",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                        })
                                      ]),
                                      _createTextVNode(" Template Transform ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("div", null, [
                                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Handlebars Template:", -1)),
                                          _createElementVNode("pre", _hoisted_87, _toDisplayString(report.transform.config.template), 1)
                                        ]),
                                        (report.transform.config.fileConfig?.enabled)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                              _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-xs font-medium text-amber-600 dark:text-amber-400 flex items-center" }, " 📎 PDF/File Generation Enabled ", -1)),
                                              _createElementVNode("div", _hoisted_89, [
                                                (report.transform.config.fileConfig.dataPath)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Data Path:", -1)),
                                                      _createElementVNode("span", _hoisted_91, _toDisplayString(report.transform.config.fileConfig.dataPath), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                                    report.transform.config.fileConfig.headers &&
                                    report.transform.config.fileConfig.headers.length > 0
                                  )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Headers:", -1)),
                                                      _createElementVNode("span", _hoisted_93, _toDisplayString(report.transform.config.fileConfig.headers.join(', ')), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (report.transform.config.fileConfig.topN)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Top N:", -1)),
                                                      _createElementVNode("span", _hoisted_95, _toDisplayString(report.transform.config.fileConfig.topN), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (report.transform.config.fileConfig.sort)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Sort:", -1)),
                                                      _createElementVNode("span", _hoisted_97, [
                                                        _createTextVNode(_toDisplayString(report.transform.config.fileConfig.sort.columns.join(', ')) + " ", 1),
                                                        _createElementVNode("span", _hoisted_98, "(" + _toDisplayString(report.transform.config.fileConfig.sort.order || 'desc') + ")", 1)
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_99, [
                                    _cache[62] || (_cache[62] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white flex items-center" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 mr-2 text-emerald-500",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                        })
                                      ]),
                                      _createTextVNode(" Slack Sink ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_100, [
                                      _createElementVNode("div", _hoisted_101, [
                                        _createElementVNode("div", _hoisted_102, [
                                          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Action:", -1)),
                                          _createElementVNode("span", {
                                            class: _normalizeClass([
                                  getSinkActionColor(report.sink.config.action),
                                  'px-2 py-0.5 rounded-full text-xs font-medium'
                                ])
                                          }, _toDisplayString(formatSinkAction(report.sink.config.action)), 3)
                                        ]),
                                        (report.sink.config.userId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                              _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "User ID:", -1)),
                                              _createElementVNode("span", _hoisted_104, _toDisplayString(report.sink.config.userId), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                                report.sink.config.userIds && report.sink.config.userIds.length > 0
                              )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                              _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "User IDs:", -1)),
                                              _createElementVNode("span", _hoisted_106, _toDisplayString(report.sink.config.userIds.length) + " users", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (report.sink.config.channelId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Channel ID:", -1)),
                                              _createElementVNode("span", _hoisted_108, _toDisplayString(report.sink.config.channelId), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (report.sink.config.threadTs)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Thread TS:", -1)),
                                              _createElementVNode("span", _hoisted_110, _toDisplayString(report.sink.config.threadTs), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (report.sink.config.file)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-xs font-medium text-amber-600 dark:text-amber-400" }, "📎 File Attachment", -1)),
                                            _createElementVNode("div", _hoisted_112, [
                                              _createElementVNode("div", _hoisted_113, [
                                                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Filename:", -1)),
                                                _createElementVNode("span", _hoisted_114, _toDisplayString(report.sink.config.file.filename), 1)
                                              ]),
                                              (report.sink.config.file.title)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Title:", -1)),
                                                    _createElementVNode("span", _hoisted_116, _toDisplayString(report.sink.config.file.title), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (report.sink.config.file.beforeContent)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Before Content:", -1)),
                                                    _createElementVNode("span", _hoisted_118, _toDisplayString(report.sink.config.file.beforeContent), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (report.sink.config.file.afterContent)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "After Content:", -1)),
                                                    _createElementVNode("span", _hoisted_120, _toDisplayString(report.sink.config.file.afterContent), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (report.schedule?.expression)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                          _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2 flex items-center" }, [
                                            _createElementVNode("svg", {
                                              class: "w-3 h-3 mr-1.5 text-blue-500",
                                              fill: "none",
                                              stroke: "currentColor",
                                              viewBox: "0 0 24 24"
                                            }, [
                                              _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                              })
                                            ]),
                                            _createTextVNode(" Schedule ")
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_122, [
                                            _createElementVNode("div", null, [
                                              _cache[54] || (_cache[54] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Human readable:", -1)),
                                              _createElementVNode("div", _hoisted_123, _toDisplayString(parseCronExpression(report.schedule.expression)), 1)
                                            ]),
                                            (getISTTime(report.schedule.expression))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                                  _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "IST Equivalent:", -1)),
                                                  _createElementVNode("div", _hoisted_125, _toDisplayString(getISTTime(report.schedule.expression)), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (report.meta?.nextRun)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                  _cache[56] || (_cache[56] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Next Run:", -1)),
                                                  _createElementVNode("div", _hoisted_127, _toDisplayString(formatEpochToIST(report.meta.nextRun)), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_128, [
                                      _cache[61] || (_cache[61] = _createElementVNode("h5", { class: "text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2 flex items-center" }, [
                                        _createElementVNode("svg", {
                                          class: "w-3 h-3 mr-1.5 text-gray-500",
                                          fill: "none",
                                          stroke: "currentColor",
                                          viewBox: "0 0 24 24"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                          })
                                        ]),
                                        _createTextVNode(" Metadata ")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_129, [
                                        _createElementVNode("div", _hoisted_130, [
                                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Created By:", -1)),
                                          _createElementVNode("span", _hoisted_131, _toDisplayString(getEmailPrefix(report.meta?.createdBy)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_132, [
                                          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Updated By:", -1)),
                                          _createElementVNode("span", _hoisted_133, _toDisplayString(getEmailPrefix(report.meta?.updatedBy)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_134, [
                                          _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Last Updated:", -1)),
                                          _createElementVNode("span", _hoisted_135, _toDisplayString(formatDate(report.updatedAt)), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (filteredReports.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_136, [
                          _createElementVNode("td", _hoisted_137, [
                            _cache[63] || (_cache[63] = _createElementVNode("svg", {
                              class: "mx-auto h-12 w-12 text-gray-400",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              })
                            ], -1)),
                            _cache[64] || (_cache[64] = _createElementVNode("h3", { class: "mt-2 text-sm font-medium text-gray-900 dark:text-white" }, " No reports found ", -1)),
                            _createElementVNode("p", _hoisted_138, _toDisplayString(searchQuery.value
                        ? 'Try adjusting your search or filters'
                        : 'Get started by creating a new report'), 1),
                            (!searchQuery.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "mt-4 px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-200 text-sm font-medium shadow-md-custom shadow-hover-md",
                                  style: {"box-shadow":"var(--shadow-md)"},
                                  onClick: openCreateModal
                                }, " Create Report "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800/80 border-gray-700' : 'bg-gray-50 border-gray-200',
            'px-6 py-4 border-t flex items-center justify-between'
          ])
                  }, [
                    _createElementVNode("div", _hoisted_139, " Showing " + _toDisplayString((currentPage.value - 1) * pageSize.value + 1) + " to " + _toDisplayString(Math.min(currentPage.value * pageSize.value, totalReports.value)) + " of " + _toDisplayString(totalReports.value) + " reports ", 1),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("button", {
                        disabled: currentPage.value === 1,
                        class: _normalizeClass([
                currentPage.value === 1
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-gray-200 dark:hover:bg-gray-700',
                _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-600',
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-colors'
              ]),
                        onClick: prevPage
                      }, " Previous ", 10, _hoisted_141),
                      _createElementVNode("div", _hoisted_142, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
                            (
                    page === 1 ||
                    page === totalPages.value ||
                    (page >= currentPage.value - 1 && page <= currentPage.value + 1)
                  )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass([
                    page === currentPage.value
                      ? 'bg-emerald-500 text-white'
                      : _unref(theme).isDark.value
                        ? 'text-gray-300 hover:bg-gray-700'
                        : 'text-gray-600 hover:bg-gray-200',
                    'w-8 h-8 rounded-lg text-sm font-medium transition-colors'
                  ]),
                                  onClick: ($event: any) => (goToPage(page))
                                }, _toDisplayString(page), 11, _hoisted_143))
                              : (page === currentPage.value - 2 || page === currentPage.value + 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_144, " ... "))
                                : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        disabled: currentPage.value === totalPages.value,
                        class: _normalizeClass([
                currentPage.value === totalPages.value
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-gray-200 dark:hover:bg-gray-700',
                _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-600',
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-colors'
              ]),
                        onClick: nextPage
                      }, " Next ", 10, _hoisted_145)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 2))
    ]),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("div", {
              class: "fixed inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showDeleteModal.value = false))
            }),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
            'relative inline-block rounded-xl text-left overflow-hidden shadow-modal transform transition-all sm:my-8 sm:max-w-lg sm:w-full'
          ]),
              style: {"box-shadow":"var(--shadow-modal)"}
            }, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("div", _hoisted_149, [
                  _cache[66] || (_cache[66] = _createElementVNode("div", {
                    class: "flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-rose-100 dark:bg-rose-900/30 shadow-md-custom",
                    style: {"box-shadow":"var(--shadow-md)"}
                  }, [
                    _createElementVNode("svg", {
                      class: "h-6 w-6 text-rose-600 dark:text-rose-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("h3", _hoisted_151, _toDisplayString(reportsToDelete.value.length > 1
                      ? `Delete ${reportsToDelete.value.length} Reports`
                      : 'Delete Report'), 1),
                    _createElementVNode("p", _hoisted_152, [
                      (reportsToDelete.value.length === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_153, " Are you sure you want to delete \"" + _toDisplayString(reportToDelete.value?.name || reportToDelete.value?.id) + "\"? This action cannot be undone. ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_154, " Are you sure you want to delete " + _toDisplayString(reportsToDelete.value.length) + " reports? This action cannot be undone. ", 1))
                    ]),
                    (reportsToDelete.value.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                          _createElementVNode("ul", _hoisted_156, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportsToDelete.value, (report) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: report.id,
                                class: "flex items-center"
                              }, [
                                _cache[65] || (_cache[65] = _createElementVNode("span", { class: "w-1.5 h-1.5 rounded-full bg-rose-500 mr-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(report.name || report.id), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("button", {
                  class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-600 hover:bg-gray-500 text-gray-200'
                  : 'bg-gray-200 hover:bg-gray-300 text-gray-700',
                'px-4 py-2 rounded-lg text-sm font-medium transition-colors'
              ]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showDeleteModal.value = false))
                }, " Cancel ", 2),
                _createElementVNode("button", {
                  class: "px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white rounded-lg text-sm font-medium transition-all duration-200 shadow-md-custom shadow-hover-md flex items-center space-x-2",
                  style: {"box-shadow":"var(--shadow-md)"},
                  disabled: isDeleting.value || isBulkDeleting.value,
                  onClick: deleteReport
                }, [
                  (isDeleting.value || isBulkDeleting.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_159, _cache[67] || (_cache[67] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(isDeleting.value || isBulkDeleting.value ? 'Deleting...' : 'Delete'), 1)
                ], 8, _hoisted_158)
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Toast, {
      show: toast.show,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((toast.show) = $event)),
      message: toast.message,
      type: toast.type,
      duration: 4000
    }, null, 8, ["show", "message", "type"])
  ]))
}
}

})